/**
 * Header JavaScript Module
 *
 * Contiene la lógica de UI del header/sidebar que antes estaba inline
 * en templates/header.php. Se ejecuta una sola vez en la carga inicial
 * (el header está fuera del turbo-frame y no se re-renderiza).
 */

/**
 * Clases CSS que marcan un enlace del sidebar como activo
 */
var ACTIVE_CLASSES = ['font-bold', 'lg:bg-[#0000000a]'];
var ACTIVE_HOVER = 'lg:hover:!bg-[#0000000a]';

/**
 * Actualiza el enlace activo del sidebar según la URL actual.
 * Se llama en la carga inicial y tras cada navegación Turbo.
 */
function updateSidebarActiveLink() {
	var menu = document.getElementById('mainmenu');
	if (!menu) return;

	var path = window.location.pathname.replace(/\/+$/, '') || '/';

	// Quitar activo de todos los enlaces del sidebar
	menu.querySelectorAll('a.' + ACTIVE_CLASSES[0]).forEach(function (a) {
		ACTIVE_CLASSES.forEach(function (c) { a.classList.remove(c); });
		a.classList.remove(ACTIVE_HOVER);
	});

	// Buscar el enlace que coincide con la ruta actual (solo enlaces de navegación dentro de <li>)
	var best = null;
	var bestLen = 0;
	menu.querySelectorAll('li > a[href]').forEach(function (a) {
		var href = (a.getAttribute('href') || '').replace(/\/+$/, '') || '/';
		// Coincidencia exacta o prefijo (para sub-rutas como /settings/business)
		if (path === href || (href !== '/' && path.indexOf(href) === 0)) {
			if (href.length > bestLen) {
				best = a;
				bestLen = href.length;
			}
		}
	});

	if (best) {
		ACTIVE_CLASSES.forEach(function (c) { best.classList.add(c); });
		best.classList.add(ACTIVE_HOVER);
	}

	// Re-detectar pestaña activa (contabilidad / usuario)
	updateAdvisoryTab();
}

/**
 * Activa la pestaña de asesoría correcta según el enlace activo
 */
function updateAdvisoryTab() {
	var menuContainer = document.getElementById('menuclienteasesoria');
	if (!menuContainer) return;

	var tabs = menuContainer.querySelectorAll('.ltab');
	if (!tabs.length) return;

	var activeInUsuario = document.querySelector('.menuusuario .font-bold');
	activarMenuAsesoria(tabs, activeInUsuario ? 'usuario' : 'contabilidad');
}

/**
 * Muestra/oculta los grupos de menú según la pestaña seleccionada
 */
function activarMenuAsesoria(tabs, menu) {
	tabs.forEach(function (el) {
		el.classList.remove('text-gray-900', 'bg-white', 'active');
		el.classList.add('text-gray-500');
	});

	var activeTab = document.querySelector('.ltab[data-menu="' + menu + '"]');
	if (activeTab) {
		activeTab.classList.remove('text-gray-500');
		activeTab.classList.add('text-gray-900', 'bg-white', 'active');
	}

	document.querySelectorAll('.menucontabilidad, .menuusuario').forEach(function (el) {
		el.classList.add('hidden');
	});

	document.querySelectorAll('.menu' + menu).forEach(function (el) {
		el.classList.remove('hidden');
	});
}

// Evita doble-bind de click en las pestañas
var _advisoryTabsBound = false;

/**
 * Inicializa las pestañas del menú de cliente asesoría
 * (contabilidad / usuario)
 */
function initAdvisoryTabs() {
	var menuContainer = document.getElementById('menuclienteasesoria');
	if (!menuContainer) return;

	var tabs = menuContainer.querySelectorAll('.ltab');
	if (!tabs.length) return;

	if (!_advisoryTabsBound) {
		_advisoryTabsBound = true;
		tabs.forEach(function (el) {
			el.addEventListener('click', function () {
				activarMenuAsesoria(tabs, this.dataset.menu);
			});
		});
	}

	// Si viene de cambio de cuenta (?change=true), ir directo a contabilidad
	var params = new URLSearchParams(window.location.search);
	if (params.get('change') === 'true') {
		activarMenuAsesoria(tabs, 'contabilidad');
	} else {
		var activeInUsuario = document.querySelector('.menuusuario .font-bold');
		activarMenuAsesoria(tabs, activeInUsuario ? 'usuario' : 'contabilidad');
	}
}

var _asesoriasMenuBound = false;

/**
 * Inicializa el toggle del menú de asesorías (slide animation)
 */
function initAsesoriasMenuToggle() {
	var btnAsesorias = document.getElementById('btn-asesorias');
	var mainMenu = document.getElementById('mainmenu');
	var partnersMenu = document.getElementById('partnersmenu');
	var btnVolver1 = document.getElementById('btn-volver-mainmenu');
	var btnVolver2 = document.getElementById('btn-volver-mainmenu-2');

	if (!btnAsesorias && !btnVolver1 && !btnVolver2) return;

	function abrirAsesorias(e) {
		if (e) e.preventDefault();
		if (mainMenu) {
			mainMenu.classList.remove('translate-x-0', 'opacity-100', 'pointer-events-auto');
			mainMenu.classList.add('-translate-x-full', 'opacity-0', 'pointer-events-none');
		}
		if (partnersMenu) {
			partnersMenu.classList.remove('-translate-x-full', 'opacity-0', 'pointer-events-none');
			partnersMenu.classList.add('translate-x-0', 'opacity-100', 'pointer-events-auto');
		}
		if (btnAsesorias) btnAsesorias.setAttribute('aria-expanded', 'true');
	}

	function volverPrincipal(e) {
		if (e) e.preventDefault();
		if (partnersMenu) {
			partnersMenu.classList.remove('translate-x-0', 'opacity-100', 'pointer-events-auto');
			partnersMenu.classList.add('-translate-x-full', 'opacity-0', 'pointer-events-none');
		}
		if (mainMenu) {
			mainMenu.classList.remove('-translate-x-full', 'opacity-0', 'pointer-events-none');
			mainMenu.classList.add('translate-x-0', 'opacity-100', 'pointer-events-auto');
		}
		if (btnAsesorias) btnAsesorias.setAttribute('aria-expanded', 'false');
	}

	if (mainMenu) {
		mainMenu.classList.add('transform', 'xl:transition-all', 'xl:duration-300', 'xl:ease-in-out', 'translate-x-0', 'opacity-100', 'pointer-events-auto');
	}

	if (!_asesoriasMenuBound) {
		_asesoriasMenuBound = true;
		if (btnAsesorias) btnAsesorias.addEventListener('click', abrirAsesorias);
		if (btnVolver1) btnVolver1.addEventListener('click', volverPrincipal);
		if (btnVolver2) btnVolver2.addEventListener('click', volverPrincipal);
	}
}

/**
 * Inicializa el popover del botón "Crear" del menú principal
 */
function initCrearPopover() {
	var btn = document.getElementById('crearBtn');
	var popover = document.getElementById('popover-bottom');
	if (!btn || !popover) return;

	var show = function () {
		popover.classList.remove('invisible', 'opacity-0');
		popover.classList.add('opacity-100');
		btn.setAttribute('aria-expanded', 'true');
	};

	var hide = function () {
		popover.classList.add('invisible', 'opacity-0');
		popover.classList.remove('opacity-100');
		btn.setAttribute('aria-expanded', 'false');
	};

	var toggle = function (e) {
		e.stopPropagation();
		if (popover.classList.contains('invisible')) {
			show();
		} else {
			hide();
		}
	};

	btn.addEventListener('click', toggle);

	document.addEventListener('click', function (e) {
		if (!popover.contains(e.target) && !btn.contains(e.target)) {
			hide();
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			hide();
		}
	});
}

/**
 * Inicializa el popover del botón "Crear" del menú de cliente
 */
function initCrearClientePopover() {
	var btnCliente = document.getElementById('crearBtnCliente');
	var popoverCliente = document.getElementById('popover-bottom-cliente');
	if (!btnCliente || !popoverCliente) return;

	var showCliente = function () {
		popoverCliente.classList.remove('invisible', 'opacity-0');
		popoverCliente.classList.add('opacity-100');
		btnCliente.setAttribute('aria-expanded', 'true');
	};

	var hideCliente = function () {
		popoverCliente.classList.add('invisible', 'opacity-0');
		popoverCliente.classList.remove('opacity-100');
		btnCliente.setAttribute('aria-expanded', 'false');
	};

	var toggleCliente = function (e) {
		e.stopPropagation();
		if (popoverCliente.classList.contains('invisible')) {
			showCliente();
		} else {
			hideCliente();
		}
	};

	btnCliente.addEventListener('click', toggleCliente);

	document.addEventListener('click', function (e) {
		if (!popoverCliente.contains(e.target) && !btnCliente.contains(e.target)) {
			hideCliente();
		}
	});

	document.addEventListener('keydown', function (e) {
		if (e.key === 'Escape') {
			hideCliente();
		}
	});
}

/**
 * Inicializa la búsqueda de cuentas y el botón de limpiar
 */
function initAccountSearch() {
	var searchInput = document.getElementById('searchInputAccount');
	if (!searchInput) return;

	var clearButton = searchInput.closest('.search-containerAccount')
		? searchInput.closest('.search-containerAccount').querySelector('.clear-button')
		: null;

	searchInput.addEventListener('input', function () {
		var termino = this.value.toLowerCase();
		var listaccounts = document.getElementById('listaccounts');
		if (listaccounts) {
			listaccounts.querySelectorAll(':scope > div').forEach(function (el) {
				var textoCuenta = el.textContent.toLowerCase();
				if (textoCuenta.indexOf(termino) > -1) {
					el.style.display = '';
				} else {
					el.style.display = 'none';
				}
			});
		}

		// Show/hide clear button based on input value
		if (clearButton) {
			if (this.value.length > 0) {
				clearButton.classList.remove('hidden');
			} else {
				clearButton.classList.add('hidden');
			}
		}
	});

	// Bind clear buttons via event delegation instead of inline onclick
	document.querySelectorAll('.search-containerAccount .clear-button').forEach(function (button) {
		button.addEventListener('click', function () {
			var container = this.closest('.search-containerAccount');
			var input = container.querySelector('#searchInputAccount');
			input.value = '';
			input.dispatchEvent(new Event('input'));
			this.classList.add('hidden');
			input.focus();
		});
	});
}

/**
 * Inicializa el botón hamburguesa del menú móvil
 */
var _hamburgerBound = false;

function initHamburgerBtn() {
	var btn = document.getElementById('hamburgerBtn');
	if (!btn || !window.Facturavia) return;
	if (_hamburgerBound) return;
	_hamburgerBound = true;

	btn.addEventListener('click', function () {
		Facturavia.openmenu();
	});

	var closeBtn = document.getElementById('closemenuBtn');
	if (closeBtn) {
		closeBtn.addEventListener('click', function () {
			Facturavia.closemenu();
		});
	}
}

/**
 * Inicializa la visibilidad del topbar y detección de app
 */
function initTopbarAndApp() {
	if (!window.ReactNativeWebView) {
		var topbar = document.getElementById('topbar');
		if (topbar) topbar.classList.remove('hidden');
	}

	if (window.Facturavia && window.Facturavia.isApp()) {
		document.body.classList.add('isapp');
		var header = document.querySelector('header');
		if (header) header.classList.add('!hidden');
	}
}

/**
 * Marca todos los <a> del header y mainmenu con data-turbo-frame="main"
 * para que Turbo los navegue como frame (sin recargar header.php)
 */
function initFrameNavigation() {
	var ids = ['mainheader', 'mainmenu'];
	for (var i = 0; i < ids.length; i++) {
		var container = document.getElementById(ids[i]);
		if (!container) continue;
		var links = container.querySelectorAll('a[href]');
		for (var j = 0; j < links.length; j++) {
			var link = links[j];
			if (link.getAttribute('data-turbo-frame')) continue;
			if (link.target === '_blank') continue;
			var href = link.getAttribute('href');
			if (!href || href.charAt(0) === '#' || href.indexOf('javascript:') === 0) continue;
			if (href.indexOf('http') === 0 && href.indexOf(window.location.origin) !== 0) continue;
			link.setAttribute('data-turbo-frame', 'main');
		}
	}
}

/**
 * Inicializa el sistema de delegación de eventos global para data-action
 * Maneja acciones comunes del header como modal, toggleMenu, link, etc.
 */
function initGlobalEventDelegation() {
	// Event delegation para todos los elementos con data-action
	document.addEventListener('click', function (e) {
		// Buscar el elemento con data-action (puede ser el target o un ancestro)
		var target = e.target.closest('[data-action]');
		if (!target) return;

		var action = target.getAttribute('data-action');

		// Prevenir comportamiento por defecto para links con data-action
		if (target.tagName === 'A' && action !== 'link' && action !== 'closeMenuAccount') {
			e.preventDefault();
		}

		// Ejecutar la acción correspondiente
		switch (action) {
			case 'openChat':
				if (window.BrevoConversations) {
					window.BrevoConversations('openChat', true);
				}
				break;

			case 'triggerMenuBusiness':
				if (window.Facturavia && typeof window.Facturavia.triggerMenuBusiness === 'function') {
					window.Facturavia.triggerMenuBusiness();
					// Focus en el input si se especifica
					var focusId = target.getAttribute('data-focus-id');
					if (focusId) {
						var focusEl = document.getElementById(focusId);
						if (focusEl) focusEl.focus();
					}
				}
				break;

			case 'triggerMenuAccount':
				if (window.Facturavia && typeof window.Facturavia.triggerMenuAccount === 'function') {
					window.Facturavia.triggerMenuAccount();
				}
				break;

			case 'closeMenuAccount':
				var accountmenu = document.getElementById('accountmenu');
				if (accountmenu) accountmenu.classList.add('hidden');
				var baccountmenu = document.getElementById('baccountmenu');
				if (baccountmenu) {
					var icon = baccountmenu.querySelector('.icon');
					if (icon) icon.classList.remove('rotate-180');
					baccountmenu.classList.remove('bg-[#eee]');
					baccountmenu.classList.add('lg:hover:bg-[#fafafa]');
				}
				break;

			case 'link':
				var url = target.getAttribute('data-url');
				if (url) {
					document.location.href = url;
				}
				break;

			case 'modal':
				var modalName = target.getAttribute('data-modal');
				if (modalName && window.Facturavia && typeof window.Facturavia.modal === 'function') {
					window.Facturavia.modal(modalName);
				}
				break;

			case 'toggleMenu':
				var menuId = target.getAttribute('data-menu');
				if (menuId && window.Facturavia && typeof window.Facturavia.toggleMenu === 'function') {
					window.Facturavia.toggleMenu(menuId);
				}
				break;

			case 'closeToggleMenu':
				if (window.Facturavia && typeof window.Facturavia.closeToggleMenu === 'function') {
					window.Facturavia.closeToggleMenu();
				}
				break;

			default:
				// Si no coincide con ninguna acción conocida, intentar llamar a un método de Facturavia
				if (window.Facturavia && typeof window.Facturavia[action] === 'function') {
					window.Facturavia[action]();
				}
				break;
		}
	});
}

/**
 * Funciones que dependen del sidebar (#mainmenu).
 * Se re-ejecutan en turbo:load cuando el sidebar aparece por primera vez
 * (p.ej. al navegar de /welcome a /).
 */
function initSidebarDependents() {
	initFrameNavigation();
	initAdvisoryTabs();
	initAsesoriasMenuToggle();
	initHamburgerBtn();
	initTopbarAndApp();
}

/**
 * Inicializa toda la lógica de UI del header
 */
export function initHeader() {
	function doInit() {
		initGlobalEventDelegation();
		initCrearPopover();
		initCrearClientePopover();
		initAccountSearch();
		initSidebarDependents();

		// Resaltar el enlace activo del sidebar en la carga inicial
		// (cuando no hay navegación Turbo que dispare turbo:frame-load)
		updateSidebarActiveLink();

		// turbo:frame-load — actualizar enlace activo del sidebar tras navegación de frame
		document.addEventListener('turbo:frame-load', function () {
			updateSidebarActiveLink();
		});

		// turbo:load — re-inicializar sidebar tras Turbo Drive visit
		// (p.ej. de /welcome a / donde el sidebar no existía antes)
		// Las funciones individuales tienen guards de idempotencia,
		// así que es seguro llamar en cada turbo:load.
		document.addEventListener('turbo:load', function () {
			initSidebarDependents();
			updateSidebarActiveLink();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', doInit);
	} else {
		doInit();
	}
}
